import type { CustomType } from "@prismicio/types-internal/lib/customtypes"

import { trackAddSlice } from "../../../../app/services/tracking"
import type { DocumentData } from "../../../documentData"
import type { SectionSliceConfig } from "../sliceTableData"

interface TrackSliceAddedArgs {
  config: SectionSliceConfig
  customType: CustomType
  data: DocumentData
}

export function trackSliceAdded(args: TrackSliceAddedArgs) {
  const { config, customType, data } = args
  const { zoneId, sliceReference, sliceVariation, sliceConfig } = config

  const documentName = data.type === "existing" ? data.meta.title : ""
  const customtypeId = customType.id
  const zone = zoneId

  // Slice is shared slice
  if (sliceConfig.type === "SharedSlice") {
    trackAddSlice({
      id: sliceConfig.id,
      variation: sliceVariation,
      sliceName: sliceConfig.name,
      type: "shared",
      zone,
      customtypeId,
      documentName,
    })
    return
  }

  // Slice is composite slice
  if (sliceConfig.type === "Slice") {
    trackAddSlice({
      id: sliceReference,
      variation: "",
      sliceName: sliceConfig.description ?? sliceReference,
      type: "composite",
      zone,
      customtypeId,
      documentName,
    })
    return
  }

  // Slice is legacy/simple slice
  trackAddSlice({
    id: sliceConfig.type,
    variation: "",
    sliceName: sliceReference,
    type: "simple",
    zone,
    customtypeId,
    documentName,
  })
}
